// extracted by mini-css-extract-plugin
export default {"section":"pendingReports_section__Yj8DW","li":"pendingReports_li__aImPq","btn":"pendingReports_btn__51VwJ"};